import React, { useEffect, useMemo, useState } from 'react';
import { TablePagination } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

export function useSmartPagination(items, resetKeys = []) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetKeys);

  const paginatedItems = useMemo(() => {
    const start = page * rowsPerPage;
    return items.slice(start, start + rowsPerPage);
  }, [items, page, rowsPerPage]);

  const handleChangePage = (_event, nextPage) => {
    setPage(nextPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return {
    page,
    rowsPerPage,
    paginatedItems,
    handleChangePage,
    handleChangeRowsPerPage,
  };
}

export default function SmartTablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = DEFAULT_ROWS_PER_PAGE_OPTIONS,
}) {
  const { t } = useTranslation();

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
      labelRowsPerPage={t('pagination.rows_per_page')}
      labelDisplayedRows={({ from, to, count: total }) =>
        t('pagination.displayed_rows', {
          from,
          to,
          count: total === -1 ? t('pagination.more_than', { to }) : total,
        })
      }
      sx={{
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        '& .MuiTablePagination-toolbar': {
          flexWrap: 'wrap',
          rowGap: 1,
        },
      }}
    />
  );
}
